
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  const handleSaveSettings = () => {
    localStorage.setItem('cookieConsent', 'custom');
    setIsVisible(false);
    setShowSettings(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-[#3a3a3a]/10 shadow-lg w-full">
      <div className="max-w-full px-6 lg:px-12 py-4">
        {!showSettings ? (
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex-1 min-w-0">
              <p className="text-sm text-[#3a3a3a]">
                Utilizamos cookies para mejorar tu experiencia. Al continuar navegando, aceptas nuestra{' '}
                <Link to="/politica-cookies" className="text-[#ffb7b4] hover:underline cursor-pointer whitespace-nowrap">
                  política de cookies
                </Link>
                .
              </p>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
              <button
                onClick={() => setShowSettings(true)}
                className="text-sm text-[#3a3a3a] hover:text-[#ffb7b4] transition-colors cursor-pointer whitespace-nowrap"
              >
                Configurar
              </button>
              <button
                onClick={handleReject}
                className="px-6 py-2 text-sm border border-[#3a3a3a] text-[#3a3a3a] hover:bg-[#3a3a3a] hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                Rechazar
              </button>
              <button
                onClick={handleAccept}
                className="px-6 py-2 text-sm bg-[#ffb7b4] text-[#3a3a3a] hover:bg-[#ff9f9c] transition-all cursor-pointer whitespace-nowrap"
              >
                Aceptar
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-[#3a3a3a]">Configuración de Cookies</h3>
            <div className="space-y-3">
              <label className="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" checked disabled className="w-4 h-4" />
                <span className="text-sm text-[#3a3a3a]">Cookies necesarias (siempre activas)</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" className="w-4 h-4" />
                <span className="text-sm text-[#3a3a3a]">Cookies analíticas</span>
              </label>
              <label className="flex items-center gap-3 cursor-pointer">
                <input type="checkbox" className="w-4 h-4" />
                <span className="text-sm text-[#3a3a3a]">Cookies de marketing</span>
              </label>
            </div>
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => setShowSettings(false)}
                className="px-6 py-2 text-sm border border-[#3a3a3a] text-[#3a3a3a] hover:bg-[#3a3a3a] hover:text-white transition-all cursor-pointer whitespace-nowrap"
              >
                Cancelar
              </button>
              <button
                onClick={handleSaveSettings}
                className="px-6 py-2 text-sm bg-[#ffb7b4] text-[#3a3a3a] hover:bg-[#ff9f9c] transition-all cursor-pointer whitespace-nowrap"
              >
                Guardar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CookieBanner;
